/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  TaxStatusMessage.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Sandeep Raja (E807238)
 *
 * @Date         : Nov 20, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Sandeep Raja (E807238)
 * On            : Nov 27, 2019
 * Description   : ASDS-1948: Unable to fetch tax in My Cart Page
 ******************************************************************************/

import * as React from 'react';

import { connect } from 'react-redux';
import '@scuf/common/honeywell/theme.css';
import './OrderSummery.css';
import '@scuf/styles/variables.scss';
import { TaxErrorNotification } from './TaxErrorNotification';

interface TaxErrorNotificationProps {
  isFetching: boolean;
  isSuccess: boolean;
  taxSuccessOrFailure?: boolean;
  severity?: string;
}

export class TaxStatusMessage extends React.PureComponent<TaxErrorNotificationProps> {
  render() {
    if (this.props.isFetching) {
      return null;
    }
    else if (!this.props.taxSuccessOrFailure) {
        return <TaxErrorNotification  {...this.props}/>;
    }
    else {
        return null;
    }
  }
}

const mapDispatchToProps = {
  
};

function mapStateToProps(state) {
  const { isFetching, isSuccess, taxSuccessOrFailure } = state.orderSummary.orderSummary;

  if (!isFetching && isSuccess) {
    return {
      isFetching,
      isSuccess,
      taxSuccessOrFailure,
    };
  }
  return {    
    isFetching,
    isSuccess,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaxStatusMessage);
